import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "pqr",
  ref: "pqrResults"
}
const _hoisted_2 = {
  class: "pqr-grid js-product-query-results",
  ref: "pqrSwiperInstance"
}
const _hoisted_3 = {
  class: "pqr-grid__item",
  "data-aos": "fade-up",
  "data-aos-once": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createVNode(_component_ProductCard, {
            portfolioType: product.portfolio,
            url: product.productDetailUrl,
            title: product.productDisplayName,
            imageUrl: product.primaryImageUrl,
            isFinishImageMissing: product.isFinishImageMissing,
            beautyImageUrl: product.beautyImageUrl,
            description: product.productBrowseDescription,
            availability: product.availability,
            modelNumber: product.modelNumber,
            index: index,
            product: product,
            translations: _ctx.translations,
            hasQuickship: product.quickShip,
            disableComparison: true,
            isDiscontinued: product.isDiscontinued,
            onComparisonItemRemoved: $options.removeComparisonItem
          }, null, 8 /* PROPS */, ["portfolioType", "url", "title", "imageUrl", "isFinishImageMissing", "beautyImageUrl", "description", "availability", "modelNumber", "index", "product", "translations", "hasQuickship", "isDiscontinued", "onComparisonItemRemoved"])
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */)
  ], 512 /* NEED_PATCH */))
}